<template>
  <section class="framer-of33pl" data-framer-name="Notes features" name="Notes features">
        <div class="framer-mflr0o" data-framer-name="Main container" name="Main container">
          <div class="framer-esgyy7" data-framer-name="Header" name="Header">
            <header class="framer-rqbuym" data-framer-name="Title" name="Title">
              <div class="framer-euf613"
                style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                data-framer-component-type="RichTextContainer">
                <h2 class="framer-text framer-styles-preset-gx26df" data-styles-preset="k3Ea6rV_p">Benefits</h2>
              </div>
              <!-- <div class="framer-fxfplw"
                style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                data-framer-component-type="RichTextContainer">
                <p class="framer-text framer-styles-preset-1ti5524" data-styles-preset="u7aiLhMMc">Organize all of your applications in one central place</p>
              </div> -->
            </header>
          </div>
          <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
            <div class="framer-lszzyx-container">
              <div class="framer-cF52d framer-9kfciy framer-v-jy8bs5" data-framer-name="Third" data-highlight="true"
                style="max-width: 100%; width: 100%; opacity: 1;">
                <div class="framer-1tfc6oj" data-framer-name="Content" style="opacity: 1;">
                  <div class="framer-11dl9gf" style="opacity: 1;">
                    <div class="framer-19brno5-container" style="opacity: 1;">
                      <div class="framer-xY0AV framer-mp0BS framer-O836p framer-jwq2ff"
                        :data-framer-name="currentStep === 0 ? 'Active' : 'Inactive'"
                        :style="currentStep === 0 ? 'opacity: 1;' : 'opacity: 0.6;'"
                        :class="currentStep === 0 ? 'framer-v-jwq2ff' : 'framer-v-1cvtkse'"
                        @click="()=>changeCurrentStep(0)"
                        data-highlight="true" style="width: 100%; will-change: transform;" tabindex="0">
                        <div class="framer-1q8lo3w" data-framer-name="Icon &amp; Title" style="opacity: 1;">
                          <div class="framer-19wheld-container" style="opacity: 1;">
                            <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="currentColor" aria-hidden="true" data-slot="icon"
                                color="var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16))"
                                style="width: 100%; height: 100%;">
                                <path fill-rule="evenodd"
                                  d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z"
                                  clip-rule="evenodd"></path>
                              </svg></div>
                          </div>
                          <div class="framer-14rwv38"
                            style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                            data-framer-component-type="RichTextContainer">
                            <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ">Matching
                              Grant</h6>
                          </div>
                        </div>
                        <div class="framer-8htzzv"
                          style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                          data-framer-component-type="RichTextContainer">
                          <p class="framer-text framer-styles-preset-rd82sx" data-styles-preset="GgYXobXuD">of up to
                            RM500,000 (including assessment, proposal, training & post project assessment) : 25% Government assistance</p>
                        </div>
                        <div class="framer-1r8tf3h" data-framer-name="Horizontal"
                          style="background-color: var(--token-b5ecd879-47d5-47a3-ba13-eda05d3b0a90, rgb(183, 183, 183)); opacity: 1;">
                          <div class="framer-ujac8e" data-framer-name="Line fill"
                            style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, rgb(255, 84, 0)); transform: none; transform-origin: 50% 50% 0px; opacity: 1;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="framer-qfw3mr-container" style="opacity: 1;">
                      <div class="framer-xY0AV framer-mp0BS framer-O836p framer-jwq2ff"
                        :data-framer-name="currentStep === 1 ? 'Active' : 'Inactive'"
                        :style="currentStep === 1 ? 'opacity: 1;' : 'opacity: 0.6;'"
                        :class="currentStep === 1 ? 'framer-v-jwq2ff' : 'framer-v-1cvtkse'"
                        @click="()=>changeCurrentStep(1)"
                        data-highlight="true" style="width: 100%; will-change: transform;" tabindex="1">
                        <div class="framer-1q8lo3w" data-framer-name="Icon &amp; Title" style="opacity: 1;">
                          <div class="framer-19wheld-container" style="opacity: 1;">
                            <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="currentColor" aria-hidden="true" data-slot="icon"
                                color="var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16))"
                                style="width: 100%; height: 100%;">
                                <path
                                  d="M19.006 3.705a.75.75 0 1 0-.512-1.41L6 6.838V3a.75.75 0 0 0-.75-.75h-1.5A.75.75 0 0 0 3 3v4.93l-1.006.365a.75.75 0 0 0 .512 1.41l16.5-6Z">
                                </path>
                                <path fill-rule="evenodd"
                                  d="M3.019 11.114 18 5.667v3.421l4.006 1.457a.75.75 0 1 1-.512 1.41l-.494-.18v8.475h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3v-9.129l.019-.007ZM18 20.25v-9.566l1.5.546v9.02H18Zm-9-6a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75H9Z"
                                  clip-rule="evenodd"></path>
                              </svg></div>
                          </div>
                          <div class="framer-14rwv38"
                            style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                            data-framer-component-type="RichTextContainer">
                            <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ">
                              Technology Assessment</h6>
                          </div>
                        </div>
                        <div class="framer-8htzzv"
                          style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                          data-framer-component-type="RichTextContainer">
                          <p class="framer-text framer-styles-preset-rd82sx" data-styles-preset="GgYXobXuD">through
                            On-Site Smart Factory Assessment (OSFA)</p>
                        </div>
                        <div class="framer-1r8tf3h" data-framer-name="Horizontal"
                          style="background-color: var(--token-b5ecd879-47d5-47a3-ba13-eda05d3b0a90, rgb(183, 183, 183)); opacity: 1;">
                          <div class="framer-ujac8e" data-framer-name="Line fill"
                            style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, rgb(255, 84, 0)); transform: none; transform-origin: 50% 50% 0px;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="framer-iv7s6m-container" style="opacity: 1;">
                      <div class="framer-xY0AV framer-mp0BS framer-O836p framer-jwq2ff"
                        :data-framer-name="currentStep === 2 ? 'Active' : 'Inactive'"
                        :style="currentStep === 2 ? 'opacity: 1;' : 'opacity: 0.6;'"
                        :class="currentStep === 2 ? 'framer-v-jwq2ff' : 'framer-v-1cvtkse'"
                        @click="()=>changeCurrentStep(2)"
                        data-highlight="true" style="width: 100%; will-change: transform;" tabindex="2">
                        <div class="framer-1q8lo3w" data-framer-name="Icon &amp; Title" style="opacity: 1;">
                          <div class="framer-19wheld-container" style="opacity: 1;">
                            <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="currentColor" aria-hidden="true" data-slot="icon"
                                color="var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16))"
                                style="width: 100%; height: 100%;">
                                <path fill-rule="evenodd"
                                  d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z"
                                  clip-rule="evenodd"></path>
                                <path
                                  d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z">
                                </path>
                              </svg></div>
                          </div>
                          <div class="framer-14rwv38"
                            style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                            data-framer-component-type="RichTextContainer">
                            <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ">Guidance
                              from Project Initiation</h6>
                          </div>
                        </div>
                        <div class="framer-8htzzv"
                          style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                          data-framer-component-type="RichTextContainer">
                          <p class="framer-text framer-styles-preset-rd82sx" data-styles-preset="GgYXobXuD">to project
                            completion</p>
                        </div>
                        <div class="framer-1r8tf3h" data-framer-name="Horizontal"
                          style="background-color: var(--token-b5ecd879-47d5-47a3-ba13-eda05d3b0a90, rgb(183, 183, 183)); opacity: 1;">
                          <div class="framer-ujac8e" data-framer-name="Line fill"
                            style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, rgb(255, 84, 0)); transform: translate3d(-132.499px, 0px, 0px) scale(0.3568, 1); transform-origin: 50% 50% 0px;">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="framer-1cyv1gp" data-border="true" data-framer-name="Image container"
                  style="--1lxxt3: 40px 0px 0px 40px; --border-bottom-width: 1px; --border-color: var(--token-b5ecd879-47d5-47a3-ba13-eda05d3b0a90, rgba(184, 184, 184, 0.2)); --border-left-width: 1px; --border-right-width: 1px; --border-style: solid; --border-top-width: 1px; background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); opacity: 1; border-radius: 16px;">
                  <div class="framer-wcsl4a" data-border="true"
                    style="--border-bottom-width: 3px; --border-color: var(--token-b5ecd879-47d5-47a3-ba13-eda05d3b0a90, rgb(183, 183, 183)); --border-left-width: 3px; --border-right-width: 3px; --border-style: solid; --border-top-width: 3px; opacity: 1; border-radius: 12px;">
                    <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                      data-framer-background-image-wrapper="true"><img decoding="async"
                        sizes="calc((max(min(min(100vw - 40px, 1064px), 960px), 250px) - NaNpx) * 1.2)"
                        :src="imagesrc" alt=""
                        style="display:block;width:100%;height:100%;border-radius:inherit;object-position:left top;object-fit:cover">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="framer-1ladqnc"
            style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
            data-framer-component-type="RichTextContainer">
            <p class="framer-text framer-styles-preset-1ti5524" data-styles-preset="u7aiLhMMc">You are also eligible to
              apply for loan from our selected financial institutions at subsidised interest rate.</p>
          </div>
        </div>
      </section>
</template>
<script>
import matchinggrant from "@/assets/originalframerhtml_files/2AmatchinggrantC7sXY6WOHYy1Mm5zwAe9THeHxU.jpg"
import technologicalassessment from "@/assets/originalframerhtml_files/2BtechnologicalassessmentCnfznb7PSY2KbxCouquwRafPig.jpg"
import guidance from "@/assets/originalframerhtml_files/2Cguidance8equV6Ja1v1AzPWfH22cl4G9kO0.jpg"
export default {
  name: 'part-5-landing-page',
  inheritAttrs: false,
  data() {
    return {
      matchinggrant,
      technologicalassessment,
      guidance,
      currentStep: 0
    }
  },
  methods: {
    changeCurrentStep(step) {
      this.currentStep = step
    }
  },
  computed: {
    imagesrc() {
      switch (this.currentStep) {
        case 0:
          return this.matchinggrant
        case 1:
          return this.technologicalassessment
        case 2:
          return this.guidance
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/msma/components/Part5LandingPage/index.vue